@switch (asset().type) {
  @case (BackgroundAssetType.Image) {
    <img
      class="background-media"
      [src]="mediaAsset()?.url"
      [style.object-fit]="mediaAsset()?.objectFit ?? BackgroundObjectFit.Cover"
      [style.object-position]="mediaAsset()?.objectPosition ?? 'center'"
      draggable="false"
      aria-hidden="true"
      alt="" />
  }
  @case (BackgroundAssetType.Video) {
    <video
      class="background-media"
      [odVideoSignedSrc]="mediaAsset()?.url ?? ''"
      [style.object-fit]="mediaAsset()?.objectFit ?? BackgroundObjectFit.Cover"
      [style.object-position]="mediaAsset()?.objectPosition ?? 'center'"
      [muted]="true"
      autoplay
      loop
      playsinline
      disablepictureinpicture
      aria-hidden="true"
      tabindex="-1"></video>
  }
  @case (BackgroundAssetType.Animation) {
    <od-background-animation [animation]="animationAsset()"></od-background-animation>
  }
}
